import { localize } from 'helpers/router';

export const COIN_DETAILS_ANONYMOUS = localize('/price/:name');
export const COIN_DETAILS = '/coin/:name';
export const COIN_DETAILS_DEPOSIT = `${ COIN_DETAILS }/deposit`;
export const COIN_DETAILS_WITHDRAW = `${ COIN_DETAILS }/withdraw`;
